export default __webpack_public_path__ + "static/media/addProduct.677b941b.svg";